import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { mergeMap } from 'rxjs/operators';
import { baseCrudUrlGetter } from '../config-getter';
import { AbstractControl, ValidatorFn } from '@angular/forms';

export interface ChangePassword {
  id?: string;
  oldPassword?: string;
  newPassword?: string;
}

@Injectable()
export class ChangePasswordService {

  constructor(
    private http: HttpClient,
  ) { }

  changePassword(payload: ChangePassword): Observable<any> {
    return from(baseCrudUrlGetter()).pipe(
      mergeMap(baseUrlAsync => {
        return this.http.post(baseUrlAsync + 'users/changeOwnPassword', payload);
      })
    );
  }
}

export const PasswordsMatchValidator: ValidatorFn = (control: AbstractControl) => {
  const newPassword = control.get('newPassword');
  const repeatedPassword = control.get('repeatedPassword');

  if (newPassword && repeatedPassword && repeatedPassword.value === newPassword.value) {
    return null
  }

  return {
    passwordMismatch: true
  };
}
